module.exports = __webpack_public_path__ + "img/master-title-mobile.69e272cf.png";